import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

type CTASectionProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  primaryLabel: string;
  primaryHref: string;
  secondaryLabel?: string;
  secondaryHref?: string;
  compact?: boolean;
};

export function CTASection({ eyebrow, title, description, primaryLabel, primaryHref, secondaryLabel, secondaryHref, compact = false }: CTASectionProps) {
  return (
    <section className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${compact ? 'py-8 sm:py-9' : 'py-10 sm:py-12'}`}>
      <div className={`relative overflow-hidden rounded-[1.15rem] bg-gradient-to-br from-forest via-leaf to-tint text-white shadow-soft sm:rounded-[1.4rem] ${compact ? 'p-5 sm:p-7 lg:p-8' : 'p-6 sm:p-10 lg:p-14'}`}>
        <div className={`absolute rounded-full bg-gold/25 ${compact ? '-right-12 -top-12 h-40 w-40' : '-right-16 -top-16 h-60 w-60'}`} />
        <div className={`relative grid lg:grid-cols-[1fr_auto] lg:items-center ${compact ? 'gap-5' : 'gap-8'}`}>
          <div>
            {eyebrow && <p className="text-xs font-black uppercase tracking-[0.18em] text-[#FFE08A] sm:text-sm sm:tracking-[0.24em]">{eyebrow}</p>}
            <h2 className={`mt-3 max-w-3xl font-black tracking-[-0.035em] ${compact ? 'text-2xl sm:text-3xl' : 'text-3xl sm:text-4xl'}`}>{title}</h2>
            {description && <p className="mt-4 max-w-2xl text-sm leading-6 text-white/90 sm:text-base">{description}</p>}
          </div>
          <div className={`flex flex-col sm:flex-row ${compact ? 'gap-2 lg:flex-row' : 'gap-3 lg:flex-col'}`}>
            <Link to={primaryHref} className={`inline-flex w-full items-center justify-center gap-2 rounded-full bg-gold font-black text-ink transition hover:bg-white sm:w-auto ${compact ? 'px-5 py-2.5 text-sm' : 'px-6 py-3'}`}>
              {primaryLabel} <ArrowRight className="h-4 w-4" />
            </Link>
            {secondaryLabel && secondaryHref && (
              <Link to={secondaryHref} className={`inline-flex w-full items-center justify-center gap-2 rounded-full border border-white/30 font-black text-white transition hover:bg-white hover:text-ink sm:w-auto ${compact ? 'px-5 py-2.5 text-sm' : 'px-6 py-3'}`}>
                {secondaryLabel}
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
